import { render, staticRenderFns } from "./MerchantPromotion.vue?vue&type=template&id=10731d84&scoped=true"
import script from "./MerchantPromotion.vue?vue&type=script&lang=js"
export * from "./MerchantPromotion.vue?vue&type=script&lang=js"
import style0 from "./MerchantPromotion.vue?vue&type=style&index=0&id=10731d84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10731d84",
  null
  
)

export default component.exports